import {ClassificationField} from "./classification-field";
import {Determinant} from "./determinant";
import {SelectOperatorType} from "./select-operator";

export class SubCatalogDeterminant extends Determinant {

  public parentCatalogField: ClassificationField;
  public subCatalogField: ClassificationField;
  public operator: SelectOperatorType;
  public classificationFieldIds: ClassificationField[];
  public classificationFields: ClassificationField[] = [];
}
